export const roomsMapper = roomsDetails => {
  const rooms = [];
  if (Array.isArray(roomsDetails)) {
    roomsDetails.forEach(roomDetail => {
      const { price: amount, type, bookings } = roomDetail;
      bookings.forEach(booking => {
        const { rooms: roomsNumber, ...bookingDetails } = booking;
        for (let i = 0; i < roomsNumber; ++i) {
          rooms.push({ ...bookingDetails, amount, type });
        }
      });
    });
  }
  return rooms;
};
